import { Component, Input, Output, EventEmitter } from "@angular/core";
import { Toast, ToastPackage, ToastrService } from "ngx-toastr";
import { NotificationElement } from "../../interfaces/notification-element";
import { flyInOut } from "../../animations/fly-in-out";

@Component({
  selector: "notification-toast",
  template: `
    <div class="notification-toast">
      <snackbar
        [notification]="notification"
        (actionPerformed)="emitClick()"
        (dismissed)="remove()"
      />
    </div>
  `,
  styleUrls: ["./notification-toast.component.scss"],
  animations: [flyInOut],
})
export class NotificationToastComponent extends Toast {
  @Input() notification: NotificationElement;
  @Output() notificationClick: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
  ) {
    super(toastrService, toastPackage);
  }

  emitClick() {
    this.notificationClick.emit();
  }
}
